import React from "react";
import PropTypes from "prop-types";

import { UIIcon } from "../../../ui";
import { clx } from "../../../../utils/Helpers";
import MaleGenderIcon from "./MaleGenderIcon";
import FemaleGenderIcon from "./FemaleGenderIcon";

import "./GenderCount.scss";

const VARIANT_CONFIG = {
  male: {
    modifier: "gender-count--male",
    Icon: MaleGenderIcon,
  },
  female: {
    modifier: "gender-count--female",
    Icon: FemaleGenderIcon,
  },
};

const GenderCount = ({
  count,
  label,
  variant,
  labelColor,
  countColor,
  icon,
  classNames,
  ...props
}) => {
  const variantConfig = variant ? VARIANT_CONFIG[variant] : null;
  const VariantIcon = variantConfig?.Icon;
  const useVariantStyles = Boolean(variant);

  const resolvedIcon =
    icon ??
    (VariantIcon ? (
      <VariantIcon />
    ) : (
      <UIIcon name="user" size={14} color={labelColor} decorative />
    ));

  return (
    <div
      className={clx(
        "gender-count",
        variantConfig?.modifier,
        classNames?.root,
      )}
      style={
        useVariantStyles
          ? undefined
          : {
              color: labelColor,
            }
      }
      {...props}
    >
      <div className={clx("gender-count__label-group", classNames?.label)}>
        <span className="gender-count__icon">{resolvedIcon}</span>
        <span
          className="gender-count__label"
          style={useVariantStyles ? undefined : { color: labelColor }}
        >
          {label}
        </span>
      </div>
      <span
        className="gender-count__count"
        style={useVariantStyles ? undefined : { color: countColor }}
      >
        {count ?? 0}
      </span>
    </div>
  );
};

GenderCount.propTypes = {
  count: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  label: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(["male", "female"]),
  labelColor: PropTypes.string,
  countColor: PropTypes.string,
  icon: PropTypes.node,
  classNames: PropTypes.object,
};

GenderCount.defaultProps = {
  count: 0,
  variant: undefined,
  labelColor: undefined,
  countColor: undefined,
  icon: undefined,
  classNames: {
    root: "",
    label: "",
  },
};

export default GenderCount;
